import tmhRequest from "@/config/tmhRequest";

export default {
  searchStoreConsumeMemberStatusInfoReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchstoreconsumememberstatusinforeportcolumn",
      method: "post",
      data: data
    });
  },

  searchStoreConsumeMemberStatusInfoReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchstoreconsumememberstatusinforeportcount",
      method: "post",
      data: data
    });
  },

  searchStoreConsumeMemberStatusInfoReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchstoreconsumememberstatusinforeportbypage",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusInfoReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchemployeeconsumememberstatusinforeportcolumn",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusInfoReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchemployeeconsumememberstatusinforeportcount",
      method: "post",
      data: data
    });
  },

  searchEmployeeConsumeMemberStatusInfoReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchemployeeconsumememberstatusinforeportbypage",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusInfoReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchdetailconsumememberstatusinforeportcolumn",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusInfoReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchdetailconsumememberstatusinforeportcount",
      method: "post",
      data: data
    });
  },

  searchDetailConsumeMemberStatusInfoReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchdetailconsumememberstatusinforeportbypage",
      method: "post",
      data: data
    });
  },

  searchListConsumeMemberStatusInfoReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/searchlistconsumememberstatusinforeport",
      method: "post",
      data: data
    });
  },
  searchMemberAnalysisReportByPage: function(data) {
    return tmhRequest({
      url: "/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage",
      method: "post",
      data: data
    });
  },
  exportConsumeMemberStatusInfoReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/consumememberstatusinforeport/exportconsumememberstatusinforeport",
      method: "post",
      responseType: "blob",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusinforeport.js